import { Check, X } from "lucide-react";

import { Button } from "@/components/ui/button";

interface ApprovalButtonsProps {
  onApprove?: () => void;
  onReject?: () => void;
  disabled?: boolean;
  approveLabel?: string;
  rejectLabel?: string;
}

const ApprovalButtons = ({
  onApprove,
  onReject,
  disabled = false,
  approveLabel = "Approve",
  rejectLabel = "Reject",
}: ApprovalButtonsProps) => (
  <div className="inline-flex items-center gap-1.5">
    {onApprove && (
      <Button
        size="sm"
        variant="outline"
        className="h-6 gap-1 border-green-200 bg-green-50 px-2 text-xs text-green-700 hover:bg-green-100"
        onClick={onApprove}
        disabled={disabled}
        aria-label={approveLabel}
      >
        <Check className="h-3 w-3" />
        {approveLabel}
      </Button>
    )}
    {onReject && (
      <Button
        size="sm"
        variant="outline"
        className="h-6 gap-1 border-gray-200 px-2 text-xs text-gray-600 hover:bg-gray-100"
        onClick={onReject}
        disabled={disabled}
        aria-label={rejectLabel}
      >
        <X className="h-3 w-3" />
        {rejectLabel}
      </Button>
    )}
  </div>
);

export default ApprovalButtons;
